export const SET_CURRENT_ROBOT_PART = 'SET_CURRENT_ROBOT_PART';

export const setCurrentRobotPart = (id) => ({
  type: SET_CURRENT_ROBOT_PART,
  payload: {
    currentRobotPartId: id
  },
});
